import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
const getMainColor = () => "var(--widget-main-color, #ee754c)";
const Container = styled.div`
  width: 100%;
  height: ${({ $widgetMode, $flow }) => {
  if ($flow || !$widgetMode) return "auto";
  return "100%";
}};
  max-height: 100%;
  min-height: 0;
  margin: 0 auto;
  padding: ${({ $widgetMode, $flow }) => {
  if ($flow) return "4px 0 0";
  return $widgetMode ? "clamp(4px, 1.2vw, 10px)" : "6px 0 0";
}};
  box-sizing: border-box;

  display: grid;
  grid-template-rows: ${({ $flow }) =>
  $flow ? "auto auto auto" : "auto minmax(0, 1fr) auto"};
  /* Sized to its content everywhere except the widget, which lives inside a
     frame of a fixed height. */
  overflow: ${({ $widgetMode, $flow }) =>
  $flow || !$widgetMode ? "visible" : "hidden"};
`;
const Title = styled.span`
  justify-self: center;
  width: min(100%, 260px);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  border-bottom: 1px solid
    ${({
  $widgetDark
}) => $widgetDark ? "rgba(246, 241, 232, 0.28)" : "#99b0ad"};

  padding-bottom: ${({
  $widgetMode
}) => $widgetMode ? "clamp(3px, 1vw, 7px)" : "10px"};
  margin-bottom: ${({
  $widgetMode
}) => $widgetMode ? "clamp(4px, 1vw, 7px)" : "10px"};

  color: ${({
  $widgetDark
}) => $widgetDark ? "#f6f1e8" : "#99b0ad"};
  font-size: ${({
  $widgetMode
}) => $widgetMode ? "clamp(11px, 2.6vw, 14px)" : "15px"};
  font-weight: 700;
  line-height: 1.1;
  text-align: center;

  svg {
    color: ${({
  $widgetDark
}) => $widgetDark ? "#f6f1e8" : "#99b0ad"};
    font-size: ${({
  $widgetMode
}) => $widgetMode ? "clamp(11px, 2.4vw, 14px)" : "14px"};
  }
`;
const Grid = styled.div`
  min-height: 0;
  width: 100%;
  padding: ${({
  $widgetMode
}) => $widgetMode ? "clamp(3px, 0.9vw, 7px)" : "0"};
  box-sizing: border-box;

  display: grid;
  grid-template-columns: ${({
  $widgetMode
}) => $widgetMode ? "repeat(4, minmax(0, 1fr))" : "repeat(auto-fill, minmax(56px, 1fr))"};

  grid-auto-rows: ${({
  $widgetMode
}) => $widgetMode ? "clamp(34px, 10vw, 46px)" : "44px"};

  gap: ${({
  $widgetMode
}) => $widgetMode ? "clamp(5px, 1.4vw, 9px)" : "8px"};

  align-content: start;

  overflow-y: ${({ $widgetMode }) => ($widgetMode ? "auto" : "visible")};
  overflow-x: hidden;

  @media (max-width: 480px) {
    grid-template-columns: ${({
  $widgetMode
}) => $widgetMode ? "repeat(4, minmax(0, 1fr))" : "repeat(auto-fill, minmax(46px, 1fr))"};
    grid-auto-rows: ${({ $widgetMode }) => ($widgetMode ? undefined : "40px")};
    gap: ${({ $widgetMode }) => ($widgetMode ? undefined : "6px")};
  }
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;

  scrollbar-width: thin;
  scrollbar-color: ${getMainColor()} transparent;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${getMainColor()};
    border-radius: 999px;
  }
`;
const Box = styled.button`
  width: 100%;
  height: 100%;
  min-width: 0;

  border: 1px solid
    ${({
  $selected,
  $widgetDark
}) => {
  if ($selected) return getMainColor();
  return $widgetDark ? "rgba(246, 241, 232, 0.28)" : "rgba(153, 176, 173, 0.9)";
}};

  border-radius: ${({
  $widgetMode
}) => $widgetMode ? "8px" : "10px"};

  background-color: ${({
  disabled,
  $selected,
  $widgetDark
}) => {
  if (disabled) {
    return $widgetDark ? "rgba(255, 255, 255, 0.06)" : "rgba(240, 240, 240, 0.95)";
  }
  if ($selected) return getMainColor();
  return $widgetDark ? "rgba(255, 255, 255, 0.06)" : "#ffffff";
}};

  color: ${({
  disabled,
  $selected,
  $widgetDark
}) => {
  if (disabled) {
    return $widgetDark ? "rgba(255, 255, 255, 0.35)" : "rgba(153, 153, 153, 0.95)";
  }
  if ($selected) return "#ffffff";
  return $widgetDark ? "#ffffff" : "#99b0ad";
}};

  font-size: ${({
  $widgetMode
}) => $widgetMode ? "clamp(0.82rem, 3vw, 1rem)" : "0.95rem"};
  font-weight: 800;
  line-height: 1;

  cursor: ${props => props.disabled ? "not-allowed" : "pointer"};

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0;
  box-sizing: border-box;

  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease;

  &:hover {
    border-color: ${({
  disabled
}) => disabled ? undefined : getMainColor()};
    background-color: ${({
  disabled,
  $selected,
  $widgetDark
}) => {
  if (disabled) {
    return $widgetDark ? "rgba(255, 255, 255, 0.06)" : "rgba(240, 240, 240, 0.95)";
  }
  if ($selected) return getMainColor();
  return $widgetDark ? "rgba(255, 255, 255, 0.11)" : "rgba(153, 176, 173, 0.12)";
}};
  }
`;
const AddButtonWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: ${({
  $widgetMode
}) => $widgetMode ? "clamp(5px, 1vw, 8px)" : "12px"};
  box-sizing: border-box;
`;

/* The "+ Pessoas" button stops at the largest party the restaurant accepts
   online, which on its own just looks broken. This says what to do instead. */
const LimitNote = styled.p`
  width: 100%;
  margin: 8px 0 0;
  text-align: center;
  font-size: 12px;
  line-height: 1.35;
  color: ${({ $widgetDark }) =>
  $widgetDark ? "rgba(246, 241, 232, 0.72)" : "#8b9793"};
`;
const AddButton = styled.button`
  min-height: ${({
  $widgetMode
}) => $widgetMode ? "28px" : "40px"};
  padding: ${({
  $widgetMode
}) => $widgetMode ? "5px 12px" : "10px 20px"};

  background-color: ${props => props.disabled ? "rgba(153, 153, 153, 0.65)" : getMainColor()};
  color: white;

  border: none;
  border-radius: ${({
  $widgetMode
}) => $widgetMode ? "8px" : "10px"};

  font-size: ${({
  $widgetMode
}) => $widgetMode ? "clamp(0.74rem, 2.4vw, 0.86rem)" : "1em"};
  font-weight: 700;

  cursor: ${props => props.disabled ? "not-allowed" : "pointer"};
  white-space: nowrap;

  &:hover {
    filter: ${props => props.disabled ? "none" : "brightness(0.96)"};
  }
`;
/* Restaurant side: one horizontal row of bubbles with a - and a + that page
   through higher and lower numbers, instead of a 420px block listing sixteen at
   once. Same limit rules, same disabled states - only the presentation. */
const PAGE_SIZE = 8;

const CompactRow = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 2px 0 0;
`;

const Bubble = styled.button`
  flex: 1 1 0;
  min-width: 0;
  /* Same 32px line as every other control on the restaurant's form. */
  height: 32px;
  padding: 0;
  border-radius: 999px;
  border: 1px solid
    ${({ $selected }) => ($selected ? "#ee754c" : "#e2ded7")};
  background: ${({ $selected }) => ($selected ? "#ee754c" : "#ffffff")};
  color: ${({ $selected }) => ($selected ? "#ffffff" : "#5d6b67")};
  font-size: 12.5px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition:
    background-color 0.12s ease,
    border-color 0.12s ease,
    color 0.12s ease;

  &:hover:not(:disabled) {
    border-color: #ee754c;
    color: ${({ $selected }) => ($selected ? "#ffffff" : "#ee754c")};
  }

  &:disabled {
    opacity: 0.4;
  }
`;

const PageStep = styled.button`
  flex: 0 0 auto;
  width: 28px;
  height: 32px;
  padding: 0;
  border-radius: 999px;
  border: 1px solid #e2ded7;
  background: #f7f5f2;
  color: #6f7c79;
  font-size: 14px;
  font-weight: 800;
  line-height: 1;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

  &:hover:not(:disabled) {
    border-color: #ee754c;
    color: #ee754c;
    background: #fff4ee;
  }

  &:disabled {
    opacity: 0.32;
  }
`;

const NumberOfPeopleSelector = ({
  numPeople,
  setNumPeople,
  from_restaurant,
  limit_people_reservation,
  widgetMode = false,
  widgetDark = false
}) => {
  const {
    t
  } = useTranslation();
  const [array, setArray] = useState(16);
  const [page, setPage] = useState(0);
  const limitPeopleReservation = Number(limit_people_reservation) || 0;
  const hasLimit = limitPeopleReservation > 0;
  const handleAddPeople = () => {
    if (from_restaurant || !hasLimit || array < limitPeopleReservation) {
      setArray(prev => prev + 16);
    }
  };
  const handleBoxClick = number => {
    if (from_restaurant || !hasLimit || number <= limitPeopleReservation) {
      setNumPeople(number);
    }
  };
  const isAddDisabled = !from_restaurant && hasLimit && array >= limitPeopleReservation;
  const compact = Boolean(from_restaurant);

  // Keep the page showing whatever is selected, so reopening the form lands on
  // the right row rather than back at one.
  useEffect(() => {
    const selected = Number(numPeople);
    if (!selected) return;
    setPage(Math.floor((selected - 1) / PAGE_SIZE));
  }, [numPeople]);

  const pageStart = page * PAGE_SIZE + 1;

  const showMore = () => {
    if (isAddDisabled) return;
    const nextPage = page + 1;
    // Grow the pool the same way the full selector's "+ Pessoas" does.
    if (nextPage * PAGE_SIZE + PAGE_SIZE > array) setArray(prev => prev + 16);
    setPage(nextPage);
  };

  if (compact) {
    return <CompactRow>
        <PageStep type="button" onClick={() => setPage(prev => Math.max(0, prev - 1))} disabled={page === 0} aria-label={t("ui.components.numberOfPeopleSelector.pessoas")} title={t("ui.components.numberOfPeopleSelector.pessoas")}>
          &minus;
        </PageStep>

        {Array.from({
        length: PAGE_SIZE
      }, (_, index) => {
        const number = pageStart + index;
        const disabled = !from_restaurant && hasLimit && number > limitPeopleReservation;
        return <Bubble key={number} type="button" $selected={Number(numPeople) === number} onClick={() => handleBoxClick(number)} disabled={disabled}>
              {number}
            </Bubble>;
      })}

        <PageStep type="button" onClick={showMore} disabled={isAddDisabled} aria-label={t("ui.components.numberOfPeopleSelector.pessoas")} title={t("ui.components.numberOfPeopleSelector.pessoas")}>
          +
        </PageStep>
      </CompactRow>;
  }

  return <Container $widgetMode={widgetMode} $flow={Boolean(from_restaurant)}>
      <Title $widgetMode={widgetMode} $widgetDark={widgetDark}>
        <FontAwesomeIcon icon={faUser} />{t("ui.components.numberOfPeopleSelector.numeroDePessoas")}</Title>

      <Grid $widgetMode={widgetMode}>
        {Array.from({
        length: array
      }, (_, index) => {
        const number = index + 1;
        const disabled = !from_restaurant && hasLimit && number > limitPeopleReservation;
        return <Box key={number} type="button" $widgetMode={widgetMode} $widgetDark={widgetDark} $selected={Number(numPeople) === number} onClick={() => handleBoxClick(number)} disabled={disabled}>
              {number}
            </Box>;
      })}
      </Grid>

      <AddButtonWrap $widgetMode={widgetMode}>
        <AddButton type="button" $widgetMode={widgetMode} onClick={handleAddPeople} disabled={isAddDisabled}>{t("ui.components.numberOfPeopleSelector.pessoas")}</AddButton>
      </AddButtonWrap>

      {!from_restaurant && hasLimit && <LimitNote $widgetDark={widgetDark}>
          {t("ui.components.numberOfPeopleSelector.moreThanLimit", {
        limit: limitPeopleReservation
      })}
        </LimitNote>}
    </Container>;
};
export default NumberOfPeopleSelector;
